import angular from 'angular';

import UserModel from '../../models/user';

function ReferralCtrl(CurrentUser, $scope, $timeout, $filter, $sanitize, $route) {
  $scope.user = CurrentUser.data;
  $scope.done = false;
  $scope.busy = false;
  $scope.referrerLinkVisible = false;
  $scope.users = {
    string: '',
    list: []
  };
  $scope.response = {};
  var focusInput = function () {
    $timeout(function () {
      document.querySelector('[name="emails"]').focus();
    });
  };
  focusInput();

  var getLink = function () {
    var baseUrl = window.location.protocol + "//" + window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
    return $sanitize(baseUrl + '/app/#/signup?referrer=' + $scope.user.referrerCode);
  };
  $scope.referrerLink = getLink();

  $scope.users.getList = function () {
    return $scope.users.string.split(',').map(function (email) {
      return email.trim();
    });
  };
  $scope.users.getString = function () {
    return $scope.users.list.join(', ');
  };

  $scope.toggleReferrerLink = function () {
    $scope.referrerLinkVisible = !$scope.referrerLinkVisible;
  };

  $scope.setResponse = function (data) {
    var emails = [];
    var error = false;
    $scope.busy = false;

    if (data.emails) {
      emails = Object.keys(data.emails).map(function (email) {
        return data.emails[email];
      });
    } else {
      error = true;
    }
    // set response message
    $scope.response = {
      invalid: $filter('filter')(emails, {
        'status': '!true'
      }),
      sent: $filter('filter')(emails, {
        'status': 'true'
      }),
      error: error
    };
    // set model value to invalid emails
    $scope.users.list = $filter('filter')(emails, {
      'status': '!sent'
    }).map(function (user) {
      return user.email;
    });
    $scope.users.string = $scope.users.getString();
    focusInput();
  };

  $scope.inviteUsers = function () {
    if ($scope.busy) {
      return;
    }
    $scope.busy = true;
    CurrentUser.api.invite({
        emails: $scope.users.getList()
      },
      function (data) {
        $scope.setResponse(data);
        $scope.done = true;
      },
      function (response) {
        $scope.setResponse(response.data, 'error');
      }
    );
  };

};
ReferralCtrl.$inject = ['CurrentUser', '$scope', '$timeout', '$filter',
  '$sanitize', '$route'
];

export default angular.module('controllers.referral', [UserModel])
  .controller('ReferralCtrl', ReferralCtrl)
  .name;



// WEBPACK FOOTER //
// ./project/modals/referral/referral.controller.js